import { React, useState } from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentClubCuidatia } from '../../components/clubCuidatia/ContentClubCuidatia'
import { ContentClubCuidatiaV2 } from '../../components/clubCuidatia/ContentClubCuidatiaV2'
import './ClubCuidatia.css'
import { animateScroll as scroll } from 'react-scroll';
import HeaderHome from '../../components/headerHome/HeaderHome'
import { Helmet } from 'react-helmet'
import { MenuLateralAB } from '../../components/menuLateralAA/MenuLateralAB'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import miembroClubCuidatia from '../../components/clubCuidatia/img-video/miembro-club-cuidatia.jpg';


export const ClubCuidatia = () => {
const [autLocalidades, setAutLocalidades] = useState(false);
const [OverleyModal, setOverleyModal] = useState("true");



    return (
        <div>
            <Helmet>
                <title>Club Cuidatia</title>
                <meta name="description" content="Bienvenido al Club Cuidatia, donde la salud y el bienestar son nuestra prioridad. Explora nuestros servicios y únete a nuestra comunidad." />
                <link rel="canonical" href="https://www.cuidatia.org/club-cuidatia" />
            </Helmet>
            <div className='headerPagina' >
                <div Id="Market">
                    <div className="headerPagina">
                        <HeaderHome
                        />
                    </div>
                </div>
            </div>
            <div className='club-cuidatia-body'>
                <section className="py-5 bg-light">
                    <div className="container">
                        <h2 className="h2-about">¿Qué es CLUB CUIDATIA?</h2>
                        <p className="subtitle">CLUB CUIDATIA es una red exclusiva para organizaciones y administraciones públicas que trabajan por la salud y el cuidado de las personas, diseñada para mejorar la oferta de servicios, fomentar la colaboración y generar oportunidades de mejora.</p>
                    </div>
                    <div className="container mt-4">
                        <div className="row align-items-center">
                            <div className="col-md-5">
                                <img src={miembroClubCuidatia} alt="Miembro de club cuidatia" className="img-fluid rounded shadow-sm"/>
                            </div>
                            <div className="col-md-7">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Pertenecer a una comunidad del sector salud.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Digitalizar documentos y mejorar procesos administrativos.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Facilitar la integración de servicios en tu empresa.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Posicionar estratégicamente tu empresa en entornos rurales y municipales.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Acceder a innovación y profesionales destacados en digitalización de la salud.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Disfrutar de servicios premium exclusivos del Club.
                                    </li>
                                    <li className="list-group-item bg-transparent">
                                        <i className="me-2"></i>✓ - Establecer conexiones con líderes y tomadores de decisiones del sector.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <ContentClubCuidatiaV2 />
                <ContentClubCuidatia />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}